import { useState, useEffect } from 'react';
import { api } from '../../api';

export default function SettingsPage() {
  const [settings, setSettings] = useState({
    twilio_account_sid: '',
    twilio_auth_token: '',
    twilio_from_number: '',
    app_base_url: '',
    custom_location_region_rules: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    api.getSettings()
      .then(data => {
        const merged = { ...settings };
        // Handle both array format [{key, value}] and object format {key: value}
        if (Array.isArray(data)) {
          for (const s of data) {
            if (s.key in merged) merged[s.key] = s.value || '';
          }
        } else if (data && typeof data === 'object') {
          for (const [key, value] of Object.entries(data)) {
            if (key in merged) merged[key] = value || '';
          }
        }
        setSettings(merged);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    setError('');
    setMessage('');
    try {
      await api.updateSettings(settings);
      setMessage('Settings saved successfully.');
    } catch (err) { setError(err.message); }
    setSaving(false);
  }

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="admin-page">
      <div className="page-header">
        <h2>System Settings</h2>
      </div>

      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-error">{error}</div>}

      <div className="settings-card">
        <h3>Twilio SMS Configuration</h3>
        <p className="text-muted">Configure Twilio to enable SMS notifications to drivers when new calls come in. Leave blank to disable SMS.</p>

        <form onSubmit={handleSave}>
          <div className="form-group">
            <label>Account SID</label>
            <input value={settings.twilio_account_sid} onChange={e => setSettings({...settings, twilio_account_sid: e.target.value})}
              placeholder="ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" />
          </div>
          <div className="form-group">
            <label>Auth Token</label>
            <input type="password" value={settings.twilio_auth_token} onChange={e => setSettings({...settings, twilio_auth_token: e.target.value})}
              placeholder="Enter new token..." />
            <small className="text-muted">Token is masked for security. Enter a new value to update.</small>
          </div>
          <div className="form-group">
            <label>From Phone Number</label>
            <input value={settings.twilio_from_number} onChange={e => setSettings({...settings, twilio_from_number: e.target.value})}
              placeholder="+15551234567" />
          </div>

          <h3 style={{ marginTop: 24 }}>Application</h3>
          <div className="form-group">
            <label>Base URL (for SMS links)</label>
            <input value={settings.app_base_url} onChange={e => setSettings({...settings, app_base_url: e.target.value})}
              placeholder="https://yourdomain.com" />
            <small className="text-muted">Used to generate claim links in SMS messages.</small>
          </div>

          <h3 style={{ marginTop: 24 }}>Custom Location Region Rules</h3>
          <p className="text-muted">Auto-assign regions for custom addresses. JSON array of rules — first match wins. Each rule: {`{"pattern": "text to match", "region": "Fort Worth|Dallas|Denton"}`}</p>
          <div className="form-group">
            <label>Rules (JSON)</label>
            <textarea value={settings.custom_location_region_rules}
              onChange={e => setSettings({...settings, custom_location_region_rules: e.target.value})}
              placeholder={'[\n  {"pattern": "Arlington", "region": "Fort Worth"},\n  {"pattern": "Plano", "region": "Dallas"}\n]'}
              rows={6} style={{ fontFamily: 'monospace', fontSize: '13px' }} />
          </div>

          <div className="modal-actions">
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Saving...' : 'Save Settings'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
